import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SmallRaiseHandToggle } from '../../raise-hand/SmallRaiseHandToggle';
import { SaveChatButton } from '../chat';
import ChatLockFileOnOff from '../chat/ChatLockFileOnOff';
import { ROLE, checkRoleLevel, getLocalMemberRole } from '../members';
import { ClickButton } from '../ui';
import { SidebarClose, SidebarSearch, SidebarSearchInput, SidebarTitle } from './SideBarOption';
import { ChatLock } from '../chat/ChatLock';
function SideBarHeader({ isMonitoring, name, onSwitchSearch, showBody, hideContent, renderInviteBtn, setOnSwitchSearch, handlerClose, handlerSearchText, }) {
    const isShowLvl = useSelector((state) => checkRoleLevel(getLocalMemberRole(state), ROLE.PRESENTER));
    const renderSub = useMemo(() => {
        if (name === 'chat') {
            return (React.createElement(React.Fragment, null,
                APP.config.option.chatFileLock && React.createElement(ChatLockFileOnOff, null),
                APP.config.option.hideParticipant && isShowLvl && React.createElement(SaveChatButton, null)));
        }
        if (name === 'member') {
            return (React.createElement(React.Fragment, null,
                React.createElement(ClickButton, { icon: "nickEdit", size: 16, color: "#000", onClick: () => APP.eventManager.publish('CHANGE_NICKNAME') }),
                renderInviteBtn && renderInviteBtn(),
                React.createElement(SidebarSearch, { onSwitchSearch: onSwitchSearch, setOnSwitchSearch: setOnSwitchSearch })));
        }
        return null;
    }, [name, isShowLvl, onSwitchSearch]);
    const renderTitleOption = useMemo(() => {
        if (name === 'chat')
            return isShowLvl && React.createElement(ChatLock, null);
        if (name === 'handler')
            return React.createElement(SmallRaiseHandToggle, null);
        return null;
    }, [name, isShowLvl]);
    const renderOption = useMemo(() => {
        if (isMonitoring)
            return null;
        return (React.createElement("div", { className: "right_sheader" },
            renderSub,
            React.createElement(SidebarClose, { handlerClose: handlerClose, iconStyles: { display: 'inline-flex' } })));
    }, [isMonitoring, renderSub]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sheader" },
            React.createElement("div", { className: "item-flex" },
                React.createElement(SidebarTitle, { isShowLvl: isShowLvl, name: name, showBody: showBody, hideContent: hideContent }),
                renderTitleOption),
            renderOption),
        onSwitchSearch && React.createElement(SidebarSearchInput, { handlerSearchText: handlerSearchText })));
}
export default SideBarHeader;
